import { gql } from '@apollo/client';

export const ALL_FREQUENCY_TYPES = gql`
  query AllFrequencyTypes {
    frequencyTypes: getFrequencyTypes {
      id
      name
    }
  }
`;
